import { Navigate, RouteObject } from 'react-router-dom';
import { MainPage } from '@/pages/MainPage';
import { Profile } from '@/pages/Profile';
import { NotFound } from '@/pages/NotFound';
import { TournamentsPage } from '@/pages/TournamentsPage';
import { TournamentsListPage } from '@/pages/TournamentsListPage';
import { TournamentFormPage } from '@/pages/TournamentFormPage';
import { TournamentDashboardPage } from '@/pages/TournamentDashboardPage';
import { NewsPage } from '@/pages/NewsPage';
import { NewsDetailPage } from '@/pages/NewsDetailPage';

export const routeConfig: RouteObject[] = [
  {
    path: '/',
    element: <MainPage />,
    errorElement: <NotFound />,
  },
  {
    path: '/profile',
    element: <Profile />,
    errorElement: <NotFound />,
  },
  {
    path: '/news',
    element: <NewsPage />,
    errorElement: <NotFound />,
  },
  {
    path: '/news/:id',
    element: <NewsDetailPage />,
    errorElement: <NotFound />,
  },
  {
    path: '/success',
    element: <Navigate to={'/'} replace />,
  },
  {
    path: '/tournaments',
    element: <TournamentsPage />,
    errorElement: <NotFound />,
    children: [
      {
        index: true,
        element: <TournamentsListPage />,
      },
      {
        path: 'create',
        element: <TournamentFormPage />,
      },
      {
        path: ':id',
        element: <TournamentDashboardPage />,
      },
      {
        path: ':id/edit',
        element: <TournamentFormPage />,
      },
    ],
  },
  {
    path: '/auth',
    element: <Navigate to={'/'} replace />,
  },
  {
    path: '/auth/*',
    element: <Navigate to={'/'} replace />,
  },
];
